import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useBridgeStatus, useWizardState } from "@/hooks/wizardQueries";
import { useWizardSession } from "@/hooks/useWizardSession";
import { computeWizardFlow, getBlockedRedirect, type WizardFlowSnapshot } from "@/lib/wizardFlow";

export function useWizardFlow(): WizardFlowSnapshot & {
  blockedRedirect: string | null;
  isLoading: boolean;
} {
  const location = useLocation();
  const wizardState = useWizardState();
  const bridgeStatus = useBridgeStatus();
  const session = useWizardSession();

  const flow = useMemo(
    () =>
      computeWizardFlow({
        state: wizardState.data,
        status: bridgeStatus.data,
        previewResult: session.previewResult,
        applyResult: session.applyResult,
        pathname: location.pathname,
      }),
    [wizardState.data, bridgeStatus.data, session.previewResult, session.applyResult, location.pathname],
  );

  const blockedRedirect = useMemo(
    () => getBlockedRedirect(location.pathname, flow),
    [location.pathname, flow],
  );

  return {
    ...flow,
    blockedRedirect,
    isLoading: wizardState.isLoading || bridgeStatus.isLoading,
  };
}
